const OPCODE = {
  SET_BIT: 1,
  SET_COLOR: 2,
  NEW_CHUNK: 3,
  SET_BUFFER_META: 4
};

class CommandWriter {
  constructor() {
    this.buf = new ArrayBuffer(1024 * 1024);
    this.view = new DataView(this.buf);
    this.offset = 0;
  }

  ensure(n) {
    if (this.offset + n > this.buf.byteLength) {
      const newBuf = new ArrayBuffer(this.buf.byteLength * 2);
      new Uint8Array(newBuf).set(new Uint8Array(this.buf));
      this.buf = newBuf;
      this.view = new DataView(this.buf);
    }
  }

  writeBufferMeta(bufferN, maxChunks) {
    this.ensure(1 + 4 + 4);

    this.view.setUint8(this.offset, OPCODE.SET_BUFFER_META); this.offset++;

    this.view.setUint32(this.offset, bufferN, true); this.offset += 4;
    this.view.setUint32(this.offset, maxChunks, true); this.offset += 4;
  }

  writeNewChunk(key, index, x, y, z) {
    this.ensure(1 + 8 + 4 + 12);

    this.view.setUint8(this.offset, OPCODE.NEW_CHUNK); this.offset++;

    this.view.setUint32(this.offset, key, true); this.offset += 4;
    this.view.setUint32(this.offset, index, true); this.offset += 4;

    this.view.setInt32(this.offset, x, true); this.offset += 4;
    this.view.setInt32(this.offset, y, true); this.offset += 4;
    this.view.setInt32(this.offset, z, true); this.offset += 4;
  }

  writeSetBit(chunkIndex, voxelIndex, bit) {
    this.ensure(1 + 4 + 4 + 1);

    this.view.setUint8(this.offset, OPCODE.SET_BIT); this.offset++;

    this.view.setUint32(this.offset, chunkIndex, true); this.offset += 4;
    this.view.setUint32(this.offset, voxelIndex, true); this.offset += 4;
    this.view.setUint8(this.offset, bit); this.offset++;
  }

  writeSetColor(chunkIndex, colorIndex, bit) {
    this.ensure(1 + 4 + 4 + 1);

    this.view.setUint8(this.offset, OPCODE.SET_COLOR); this.offset++;

    this.view.setUint32(this.offset, chunkIndex, true); this.offset += 4;
    this.view.setUint32(this.offset, colorIndex, true); this.offset += 4;
    this.view.setUint8(this.offset, bit); this.offset++;
  }
}

function getVoxelOffset(x, y, z) {
  const localX = x & 1;
  const localY = y & 1;
  const localZ = z & 1;

  return Math.floor(
    localX +
    (localY << 1) +
    (localZ << 2));
}

function colorVoxelIndexToXYZ(N, index) {
  // Constants
  const d = 2*N*N;
  const Nh = N / 2;
  const width = 3 * Nh;

  const z = Math.floor(index / d);

  index %= d;

  var x, y;
  y = Math.floor(index / N);
  if (y < Nh) {
    x = Nh + index % N;
  } else {
    index -= Nh*N;
    x = index % width;
    y = Math.floor(index/width) + Nh;
  }

  return {x,y,z}
}

function colorVoxelXYZToIndex(N, x, y, z) {
  const d = 2 * N * N;
  const Nh = N / 2;
  const width = 3 * Nh;

  let index;

  if (y < Nh) {
    index = (x - Nh) + N*y;
  } else {
    index = N*Nh;
    index += x + (y - Nh) * width;
  }

  return z * d + index;
}

function voxelIndex(N, x, y, z) {
  return x + N * (y + N * z);
}

function getChunkKey(x,y,z) {
  return ((z & 0x3FF) << 20) |
  ((y & 0x3FF) << 10) |
  (x & 0x3FF);
}


class FakeSubArray3D {
  constructor(parent_w, parent_h, parent_d, x0, y0, z0, sx, sy, sz) {
    this.parent_w = parent_w;
    this.parent_h = parent_h;
    this.parent_d = parent_d;

    this.x0 = x0;
    this.y0 = y0;
    this.z0 = z0;
  }

  index(x,y,z) {
    return (
      (this.x0 + x) +
      (this.y0 + y) * this.parent_w +
      (this.z0 + z) * this.parent_w * this.parent_h
    );
  }
}

class Chunk {
  constructor(N, maxNumChunks, index, x,y,z) {
    this.N = N;

    this.x = x;
    this.y = y;
    this.z = z;
    this.index = index;

    this.tx = 0;
    this.ty = 0;
    this.tz = this.index * N;

    const buffer_w = 3 * N;
    const buffer_h = 3 * N;
    const buffer_d = 1 * N * maxNumChunks;

    const cs = this.N;
    const vs = cs / 2;
    this.voxelBuffer = new FakeSubArray3D(
      buffer_w, buffer_h, buffer_d,
      this.tx, this.ty, this.tz,
      cs + vs, cs + vs, vs)
  }

  addVoxel(x, y, z, color_index, writer) {
    const cmds = [];

    x -= this.x
    y -= this.y
    z -= this.z

    var xf = Math.floor(x / 2);
    var yf = Math.floor(y / 2);
    var zf = Math.floor(z / 2);

    if (xf < this.N && yf < this.N && zf < this.N) {
      const offset = getVoxelOffset(x, y, z);

      const VI = this.voxelBuffer.index(xf, yf, zf);

      console.log(xf,yf,zf,this.N, VI)
      // console.log(`buffer[${VI}] set bit of ${offset}`)
      cmds.push(`buffer[${VI}] set bit of ${offset}`)
      // writer.writeSetBit(this.index, VI, offset);

      const CI_t = colorVoxelIndexToXYZ(this.N, voxelIndex(this.N, x,y,z));
      console.log(CI_t, voxelIndex(this.N, x,y,z));
      const CI = this.voxelBuffer.index(CI_t.x, CI_t.y, CI_t.z);
      console.log(`buffer[${CI}] set value of ${offset} to ${color_index}`)

      cmds.push(`buffer[${CI}] set value of ${offset} to ${color_index}`)
      // writer.writeSetColor(this.index, CI, offset, color_index);

      return cmds;
    }
    console.error(`Voxel (${x}, ${y}, ${z}) out of chunk bounds`)
    return cmds;
  }
}

class FakeVoxelScreen {
  constructor(N, maxNumChunks) {
    this.N = N;
    this.maxNumChunks = maxNumChunks;
    this.chunks = new Map();

    this.writer = new CommandWriter();
    this.cmds = new Array();

    // this.writer.writeBufferMeta(N, maxNumChunks);
  }

  nextFreeChunkIndex() {
    const chunkIndices = Array();
    for (const [i, chunk] of this.chunks.entries()) {
      chunkIndices.push(chunk.index);
    }

    chunkIndices.sort((a,b) => a-b);
    for (var i = 0; i < this.maxNumChunks; ++i) {
      if (chunkIndices[i] != i)
        return i;
    }
    console.error("Exceeded maximum number of chunks!");
    return 0;
  }

  addVoxel(x, y, z, color_index) {
    // chunk coordinates
    var cx = Math.floor(x / this.N) * this.N;
    const cy = Math.floor(y / this.N) * this.N;
    const cz = Math.floor(z / this.N) * this.N;
    const key = getChunkKey(cx, cy, cz);

    if (!this.chunks.has(key)) {
      const index = this.nextFreeChunkIndex();
      this.chunks.set(key, new Chunk(this.N, this.maxNumChunks, index, cx,cy,cz))

      this.cmds.push(`New chunk[${key}](${index}, ${cx}, ${cy}, ${cz}`)
      // this.writer.writeNewChunk(key, index, cx, cy, cz);
    }

    const chunk = this.chunks.get(key);
    const cmds = chunk.addVoxel(x, y, z, color_index, this.writer)
    for (const cmd of cmds) {
      this.cmds.push(cmd);
    }
  }
}

export { FakeVoxelScreen };
